import { writable } from "svelte/store";

export const isFavHandlerReady = writable(true);
